import React, { useEffect, useState } from 'react';
import '../css/surveyCss.css';
import UpcominSurveyTimer from '../component/UpcomingSurveyTimer';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import {SURVEYURL} from "../Apiurl"
import SurveyExpired from '../component/SurveyExpired';
import InactiveSUrvey from "../component/InactiveSurvey"
import LiveSurvey from '../component/LiveSurvey';
import Loading from '../component/Loading';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function SurveyJoin() {
  const params=useParams()
  const [status,setStatus]=useState("Live")
  const [type,setType]=useState("")
  const [loading,setLoading]=useState(true)
  const [startingDate,setStartingDate]=useState(new Date())

  const checkSurveyStatus=async ()=>{
   try{
       const {data}=await axios.post(`${SURVEYURL}/check/survey/status`,{key:params?.key})
       if(data?.success){
         if(data?.status=="Live"){
            setStatus("Live")
            setLoading(false)
            setType(data?.type)
         }
         else if(data?.status=="Upcoming"){
            setStartingDate(data?.starting_date)
            setStatus("Upcoming")
            setLoading(false)
         }else{
            setStatus("Expired")
            setLoading(false)
         }
       }else{
         setStatus("Inactive")
         setLoading(false)
       }
   }catch(err){
      setStatus("Inactive")
      setLoading(false)
   }
  }
  useEffect(()=>{
     if(params && params?.key)
     checkSurveyStatus()
  },[params])

  return (
    <div className="survey-container">
        {
            loading ? <Loading/> : status=="Upcoming"? <UpcominSurveyTimer startingDate={startingDate}/> : status=="Expired"?<SurveyExpired/> : status=="Live"?<LiveSurvey type={type}/> :<InactiveSUrvey/>
        }
              <ToastContainer/>
    
    </div>
  );
}

export default SurveyJoin;
